import { ApplicationConfig, provideZoneChangeDetection, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAuth0 } from '@auth0/auth0-angular';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import * as Sentry from "@sentry/angular";

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch()),
    provideNoopAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    provideAuth0({
      domain: 'auth.onlyusedtesla.com',
      clientId: 'SYgJRLa1M02HavVUOJohQyaJ2UoMIaUJ',
      authorizationParams: {
        redirect_uri: window.location.origin + '/callback',
        audience: 'https://api.onlyusedtesla.com',
        scope: 'openid profile email write:listings',
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
    }),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: '6LfC2nUqAAAAABfbSrFLhYefjwTvEEHaick7YGie',
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    }
  ],
};
